import axios from 'axios';

const postData = ({ email }) => {
  const POST_API = 'https://ht6a0a1rml.execute-api.us-west-2.amazonaws.com/dev/submit';
  const config = { SHEET_ID: '1bZZ8G97VJ9k0B3Luf24dNuq0sepTZKXQxWeFw3Pwi24' };
  return axios.post(`${POST_API}?form=subscribe`, { email, ...config });
};

export default postData;
